































































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BRow,
  BTable,
  BSpinner,
  BFormTextarea
} from "bootstrap-vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { ExportDonnee, UpdateExportDonneeModel } from "@/api/models/exportDonnees/export";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
    BFormTextarea
  },
  name: "update-export",
})
export default class EditEquipe extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateExportDonneeSidebarActive!: boolean;
  @Prop({ required: true }) exportDonneeId!: string;

  loading = false;
  required = required;
  loadingExport = false;



  exportDonnee: UpdateExportDonneeModel = {};

  async created() {
    await this.$http.myressif.exportDonnees
      .getById(this.exportDonneeId)
      .then((res: ExportDonnee) => {
        this.exportDonnee = res;
        this.loadingExport = true;
      });
  }

  resetForm() {
    this.exportDonnee = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.exportDonnees
      .update(
        this.exportDonneeId,
        this.exportDonnee
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification de l'équipe",
            text: "Equipe modifiée avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refetch-export");
        this.$emit("update:is-update-export-sidebar-active", false);
        this.loading = false;
      });
  }
}
